import { useQuery } from "@tanstack/react-query";

import { fetchActiveBanner } from "~/api/banner";

export const useHubBanner = () => {
  return useQuery({
    queryKey: ["hub-banner"],
    queryFn: fetchActiveBanner,
    staleTime: 5 * 60 * 1000,
  });
};
